<div class="image-preview-dialog" (click)="close()">
  <span class="ui-icon-close ui-icon-button no-border close-button" (click)="close(); $event.stopPropagation()"></span>
  <img
    *ngIf="!loadFailed"
    [appAuthSrc]="data.url"
    (authError)="onError()"
    (click)="$event.stopPropagation()"
    alt=""
    class="preview-image"
  />
  <div *ngIf="loadFailed" class="preview-failed" (click)="$event.stopPropagation()">
    <mat-icon aria-hidden="true">hide_image</mat-icon>
  </div>
</div>
